import _ from "lodash";

import AppConstants from "../constants/AppConstants";
import FileUtils from "../utils/FileUtils";
import { getExternalAssetURL, isExternalAssetKey } from "../utils/ExternalAssetUtils";

const { ASSET_IMAGE_ONLY_EXTS, ASSET_WIDTHS, GRAPHIC_SCALE_FILL, GRAPHIC_SCALE_ZOOM } =
  AppConstants;

/**
 * This class is used to manage some of the common operations around dealing with assets within the app
 */

const getURL = ({ key, op, assetUrl, provider }) => {
  if (isExternalAssetKey(key)) {
    return getExternalAssetURL(key, op, provider);
  }

  const url = `${assetUrl}/${op}/${key}`;
  const isPreviewPng =
    op === "preview" && _.indexOf(ASSET_IMAGE_ONLY_EXTS, FileUtils.getExt(key)) < 0;

  return isPreviewPng ? `${url}.png` : url;
};

const determineSize = (size) => {
  if (ASSET_WIDTHS.indexOf(size) >= 0) {
    return size;
  }

  var closest = null;

  for (var i = 0; i < ASSET_WIDTHS.length && closest === null; i++) {
    if (ASSET_WIDTHS[i] > size || i === ASSET_WIDTHS.length - 1) {
      closest = ASSET_WIDTHS[i];
    }
  }

  return closest;
};

const getAssetURL = ({ content, elemProps, assetUrl }) => {
  const key = content.get("key");
  const aspRatio = content.get("aspect_ratio");
  const width = elemProps.get("w");
  const height = elemProps.get("h");
  let scale = 1;
  const scaleType = elemProps.getIn(["gs", "t"], GRAPHIC_SCALE_FILL);
  if (scaleType === GRAPHIC_SCALE_ZOOM) {
    scale = elemProps.get("pct", 100) / 100;
  }
  let fileWidth = width;
  const re = /(?:\.([^.]+))?$/;
  const ext = re.exec(key)[1];
  if (ext === "gif" || ext === "svg") {
    fileWidth = "file";
  } else {
    const ratio = width / height;
    if (ratio < aspRatio) {
      fileWidth = height * aspRatio;
    }
    fileWidth = fileWidth * scale;
    fileWidth = determineSize(fileWidth);
  }
  return getURL({ key, op: fileWidth, assetUrl, provider: content.get("provider") });
};

const AssetManager = {
  determineSize,
  getAssetURL,
  getURL,
};

export default Object.freeze(AssetManager);
